// extracted by mini-css-extract-plugin
export default {"reason":"MemoContent__reason--AlCYI"};